import { configure } from 'mobx';
import { createContext } from 'react';

import AgentStore from './agentStore';
import ClerkStore from './clerkStore';
import CommonStore from './commonStore';
import DepositSalesTicketStore from './depositSalesTicketStore';
import FrameStore from './frameStore';
import QrTicketStore from './qrTicketStore';
import ReservationStore from './reservationStore';
import TicketPriceStore from './ticketPriceStore';
import InformationStore from './InformationStore';

configure({ enforceActions: 'always' });

export class RootStore {
  commonStore: CommonStore;
  agentStore: AgentStore;
  clerkStore: ClerkStore;
  ticketPriceStore: TicketPriceStore;
  depositSalesTicketStore: DepositSalesTicketStore;
  qrTicketStore: QrTicketStore;
  frameStore: FrameStore;
  reservationStore: ReservationStore;
  informationStore: InformationStore;

  constructor() {
    this.commonStore = new CommonStore(this);
    this.agentStore = new AgentStore(this);
    this.clerkStore = new ClerkStore(this);
    this.ticketPriceStore = new TicketPriceStore(this);
    this.depositSalesTicketStore = new DepositSalesTicketStore(this);
    this.qrTicketStore = new QrTicketStore(this);
    this.frameStore = new FrameStore(this);
    this.reservationStore = new ReservationStore(this);
    this.informationStore = new InformationStore(this);
  }
}

export const RootStoreContext = createContext(new RootStore());
